module.exports = __webpack_public_path__ + "static/media/MMM-Sites.4d30e663.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Offer/MMM-Sites.pdf
// module id = 402
// module chunks = 0